import john from "./assets/customer-images/john.png";
import emily from "./assets/customer-images/emily.png";
import jennifer from "./assets/customer-images/jennifer.png";
import micheal from "./assets/customer-images/micheal.png";
import sarah from "./assets/customer-images/sarah.png";
import christopher from "./assets/customer-images/christopher.png";
import daniel from "./assets/daniel-jackson-modified.png";
import lisa from "./assets/lisa-smith-modified.png";
import hannah from "./assets/hannah-nelson-modified.png";
import markus from "./assets/markus-smith-modified.png";
import andrea from "./assets/andrea-aiaqua-modified.png";

export const customerReviews = [
  {
    fullName: "John Smith",
    image: john,
    rating: 5,
    description:
      "The service provided by Woodlock was exceptional. The customer support was quick to respond to my queries, and the delivery was prompt. I'm highly satisfied with my overall experience.",
  },
  {
    fullName: "Emily Johnson",
    image: emily,
    rating: 4,
    description:
      "I had a great experience with Woodlock. The product I ordered was of high quality, and it arrived within the estimated delivery time. The only suggestion I have is to improve the packaging.",
  },
  {
    fullName: "Jennifer Davis",
    image: jennifer,
    rating: 5,
    description:
      "I'm extremely impressed with the service provided by this e-commerce brand. The website was user-friendly, and the checkout process was seamless. The product arrived in perfect condition, and I would definitely recommend them.",
  },
  {
    fullName: "Michael Wilson",
    image: micheal,
    rating: 5,
    description:
      "I had a good experience with this e-commerce brand. The customer service was helpful when I had questions about the product. The delivery was on time, and I'm satisfied with my purchase.",
  },
  {
    fullName: "Sarah Thompson",
    image: sarah,
    rating: 5,
    description:
      "Woodlock brand exceeded my expectations. The product I ordered was exactly as described, and the delivery was quick. I'm a happy customer and would buy from them again.",
  },
  {
    fullName: "Christopher Martinez",
    image: christopher,
    rating: 4,
    description:
      "Overall, I had a positive experience with this e-commerce brand. The product was of good quality, and the customer service was responsive. However, there was a slight delay in the delivery.",
  },
];

export const roles = [
  { name: "Daniel Jackson", role: "Founder/Owner", image: daniel, id: "r1" },
  { name: "Lisa Smith", role: "E-commerce Manager", image: lisa, id: "r2" },
  {
    name: "Markus Smith",
    role: "Digital Marketing Specialist",
    image: markus,
    id: "r3",
  },
  {
    name: "Andrea Piaqua",
    role: "Customer Service Representative",
    image: andrea,
    id: "r4",
  },
  {
    name: "Hannah Nelson",
    role: "Web Developer/Designer",
    image: hannah,
    id: "r5",
  },
];
